import { i18n } from './i18n';

type FirebaseAuthError = {
  code?: string;
  message?: string;
  name?: string;
};

type FirebaseErrorUI = {
  title: string;
  message: string;
};

export const handlePhoneAuthError = (error: unknown): FirebaseErrorUI => {
  const err = error as FirebaseAuthError;

  switch (err.code) {
    case 'auth/invalid-phone-number':
      return {
        title: i18n.t('sign_in.login.errorTitle.invalidPhoneNumber'),
        message: i18n.t('sign_in.login.errorMessage.invalidPhoneNumber')
      };
    case 'auth/missing-phone-number':
      return {
        title: i18n.t('sign_in.login.errorTitle.missingPhoneNumber'),
        message: i18n.t('sign_in.login.errorMessage.missingPhoneNumber')
      };
    case 'auth/quota-exceeded':
      return {
        title: i18n.t('sign_in.login.errorTitle.quotaExceeded'),
        message: i18n.t('sign_in.login.errorMessage.quotaExceeded')
      };
    case 'auth/user-disabled':
      return {
        title: i18n.t('sign_in.login.errorTitle.userDisabled'),
        message: i18n.t('sign_in.login.errorMessage.userDisabled')
      };
    case 'auth/operation-not-allowed':
      return {
        title: i18n.t('sign_in.login.errorTitle.operationNotAllowed'),
        message: i18n.t('sign_in.login.errorMessage.operationNotAllowed')
      };
    case 'auth/invalid-verification-code':
      return {
        title: i18n.t('sign_in.login.errorTitle.invalidVerificationCode'),
        message: i18n.t('sign_in.login.errorMessage.invalidVerificationCode')
      };
    case 'auth/code-expired':
      return {
        title: i18n.t('sign_in.login.errorTitle.codeExpired'),
        message: i18n.t('sign_in.login.errorMessage.codeExpired')
      };
    case 'auth/missing-verification-code':
      return {
        title: i18n.t('sign_in.login.errorTitle.missingVerificationCode'),
        message: i18n.t('sign_in.login.errorMessage.missingVerificationCode')
      };
    case 'auth/invalid-verification-id':
      return {
        title: i18n.t('sign_in.login.errorTitle.invalidVerificationId'),
        message: i18n.t('sign_in.login.errorMessage.invalidVerificationId')
      };
    default:
      return {
        title: i18n.t('sign_in.login.errorTitle.generic'),
        message: err.message || i18n.t('sign_in.login.errorMessage.generic')
      };
  }
};

export const handleEmailSignInError = (error: unknown): FirebaseErrorUI => {
  const err = error as FirebaseAuthError;

  switch (err.code) {
    case 'auth/invalid-email':
      return {
        title: i18n.t('sign_in.login.errorTitle.invalidEmail'),
        message: i18n.t('sign_in.login.errorMessage.invalidEmail')
      };
    case 'auth/missing-email':
      return {
        title: i18n.t('sign_in.login.errorTitle.missingEmail'),
        message: i18n.t('sign_in.login.errorMessage.missingEmail')
      };
    case 'auth/user-not-found':
      return {
        title: i18n.t('sign_in.login.errorTitle.userNotFound'),
        message: i18n.t('sign_in.login.errorMessage.userNotFound')
      };
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return {
        title: i18n.t('sign_in.login.errorTitle.invalidCredential'),
        message: i18n.t('sign_in.login.errorMessage.invalidCredential')
      };
    case 'auth/missing-password':
      return {
        title: i18n.t('sign_in.login.errorTitle.missingPassword'),
        message: i18n.t('sign_in.login.errorMessage.missingPassword')
      };
    case 'auth/too-many-requests':
      return {
        title: i18n.t('sign_in.login.errorTitle.tooManyRequests'),
        message: i18n.t('sign_in.login.errorMessage.tooManyRequests')
      };
    case 'auth/user-disabled':
      return {
        title: i18n.t('sign_in.login.errorTitle.userDisabled'),
        message: i18n.t('sign_in.login.errorMessage.userDisabled')
      };
    default:
      return {
        title: i18n.t('sign_in.login.errorTitle.generic'),
        message: err.message || i18n.t('sign_in.login.errorMessage.generic')
      };
  }
};
